var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", {}, [
    _c(
      "a",
      {
        staticClass:
          "button button__size-1 button__font--size-1 button__bg--dark",
        on: {
          click: function ($event) {
            $event.preventDefault()
            return _vm.login_user.apply(null, arguments)
          },
        },
      },
      [
        _c(
          "span",
          {
            staticClass:
              "font__family--gotham font__weight--medium font__color--white",
          },
          [
            _vm._v(
              "\n                " +
                _vm._s(_vm.$t("login", "user_account")) +
                "\n"
            ),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }